import ChainList from './ChainList';
import './ChainList.scss';

export default ChainList;
